/* eslint-disable no-console */
import { Response as AffiliateResponse } from '../../api/typegen/affiliate/data/{provider}/get';
import { datadogLogs } from '@datadog/browser-logs';
import { GenericError } from '../../api';
import { getBaseDomain } from '../../utils/domain';
import { isNotProduction } from 'utils/isNotProduction';
import { routes } from '../../routes';
import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axiosInstance from '../../utils/axiosInstance';

import Cookies from 'js-cookie';
import RegistrationLoading from '../RegistrationLoading/RegistrationLoading';
import useSmartlook from '../../hooks/useSmartlook';

export default function AffiliateProvider() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const { error } = useSmartlook();

  useEffect(() => {
    const fetchAndRedirect = async (provider: string) => {
      try {
        const path = `/affiliate/data/${provider}${location.search}`;

        const affiliate = (await axiosInstance.get(path, {})) as {
          data: AffiliateResponse;
        };

        const affiliateData = affiliate.data;

        datadogLogs.logger.info('Affiliate Data Requested', {
          affiliate: affiliateData,
        });

        if (!affiliateData?.token) {
          const message = `Missing token for affiliate: "${provider}"`;
          error('[AffiliateProvider][fetchAndRedirect]', message);
        }

        if (!affiliateData?.partner) {
          const message = `Missing partner for affiliate: "${provider}"`;
          error('[AffiliateProvider][fetchAndRedirect]', message);
        }

        const options: Cookies.CookieAttributes = {
          expires: 7,
          domain: getBaseDomain(),
        };

        Cookies.set(
          'affiliateRedirectUrl',
          affiliateData?.redirectUrl || '',
          options,
        );
        Cookies.set('affiliateProvider', affiliateData?.provider, options);
        Cookies.set('affiliatePartner', affiliateData?.partner || '', options);
        Cookies.set('affiliateToken', affiliateData?.token || '', options);
        Cookies.set('affiliateCookieCreated', String(Date.now()), options);

        if (!affiliateData?.redirectUrl) {
          navigate(routes.FirstLoan);
          return;
        }

        const redirectUrl = isNotProduction()
          ? (affiliateData?.redirectUrl || '').replace(
              'https://registration-vivus-es.stage.4finance.com',
              process.env.REACT_APP_VIVUS_URL || '',
            )
          : affiliateData.redirectUrl;
        window.location.assign(redirectUrl);
      } catch (e: unknown) {
        datadogLogs.logger.error(
          `AffiliateProvider > fetchAndRedirect failed!`,
          {
            affiliate: {
              provider,
            },
          },
          e instanceof Error ? e : undefined,
        );

        if (e instanceof GenericError && e?.status === 404) {
          console.error(`Affiliate not found: "${provider}"`);
        } else {
          console.error(`AffiliateData call failed, ${e}`);
        }
        navigate(routes.FirstLoan);
      }
    };

    const providerName = params.providerName;

    if (!providerName) {
      console.error('No provider name');
      navigate(routes.FirstLoan);
      return;
    }

    fetchAndRedirect(providerName);
  }, []);

  return <RegistrationLoading />;
}
